import { AmpProduct, useTrackAmpClicked } from '@/utils/amplitude/analytics';
import { getCatalogSellerId, getCatalogTitle } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getCatalogUrl } from '@/utils/urls';
import { trackFeaturedCatalogClick } from '@/redux/modules/analytics';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router';

export const useTrackAndNavigateCatalogCardClick = (catalogId: number) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const trackAmpClicked = useTrackAmpClicked();

    const title = useAppSelector((state) => getCatalogTitle(state, catalogId));
    const catalogUrl = useMemo(() => getCatalogUrl(catalogId, title), [catalogId, title]);
    const houseId = useAppSelector((state) => getCatalogSellerId(state, catalogId));

    return useCallback(() => {
        dispatch(trackFeaturedCatalogClick(catalogId));
        trackAmpClicked({
            ampProduct: AmpProduct.FeaturedAuctions,
            catalogId,
            houseId,
        });
        navigate(catalogUrl);
    }, [catalogId, catalogUrl, dispatch, houseId, navigate, trackAmpClicked]);
};
